const mutations = {
    COMMIT_BANKS: (state, payload) => {
        state.banks = payload
    },
}


export default mutations